import { FormType } from '../../../form-types';

export const hairlossPhotos: FormType = {
  name: 'Hairloss Photos',
  questions: [
    'hairlossPhotos_frontHeadPhoto',
    'hairlossPhotos_topOfScalp',
    'hairlossPhotos_backOfHeadPhoto',
    'hairlossPhotos_leftSideOfHeadPhoto',
    'hairlossPhotos_rightSideOfHeadPhoto'
  ]
};
